export const exProps = (...propsNames: string[]) => {
  return {
    shouldForwardProp: (prop: string) => !propsNames.includes(prop)
  }
}
